var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.002,
    height: 45.999,
    enableBackground: "new 0 0 26.002 45.999",
    viewBox: "0 0 26.002 45.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.998 40.094a3.484 3.484 0 010 4.893 3.404 3.404 0 01-4.846 0L1.004 25.447a3.486 3.486 0 010-4.895L20.152 1.014a3.402 3.402 0 014.846 0 3.484 3.484 0 010 4.893L9.295 23l15.703 17.094z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.1dbcedded7935e83c4a14b83e34913ed.svg";
export { ForwardRef as ReactComponent };